export enum RestoreDbTypes {
  CUSTOMER = "Customer",
  OWNER_OPERATOR = "OwnerOperator",
  CDL_DRIVER = "CDLDriver",
  QUARRY = "Quarry",
  JOB = "Job",
}

export enum TableView {
  MAIN = "main",
  DEPENDENT = "dependent",
}

export enum RestoreDBServiceType {
  CUSTOMER = "customers",
  OWNER_OPERATOR = "ownerOperators",
  CDL_DRIVER = "cdlDrivers",
  QUARRY = "quarries",
  JOB = "jobs",
}

export enum RestoreDBModalModes {
  RESTORE = "restore",
  DELETE = "delete",
}
